import { Box, Container, Typography } from "@mui/material";
import { useSuperChatLogSessionList } from "./useSuperChatLogSessionList";
import SuperChatLog from "@/templates/SuperChatLog";

/**
 * 채팅 로그 세션 리스트 페이지
 *
 * @description 채팅 세션 목록을 조회하고 관리하는 페이지
 * @author Max <sud665@ymjlab.com>
 * @version 1.0.0
 * @since 2025-01-20
 */
export default function SuperChatLogSessionList() {
  const {
    // 상태
    sessions,
    loading,
    error,
    pagination,
    filters,
    snackbarOpen,
    snackbarMessage,
    selectedSession,
    sessionDetailOpen,

    // 핸들러
    handlePageChange,
    handleLimitChange,
    handleFilterChange,
    handleResetFilters,
    handleRefresh,
    handleExport,
    handleViewSession,
    handleCloseSessionDetail,
    handleSnackbarClose,
  } = useSuperChatLogSessionList();

  console.log("pagination", pagination);

  return (
    <Container maxWidth={"xl"}>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        gap={2}
        alignItems={"end"}
        mb={2}
      >
        <Typography
          component={"h1"}
          variant="h5"
          fontWeight={"bold"}
          gutterBottom
        >
          채팅 세션 목록
        </Typography>
      </Box>

      <SuperChatLog.SessionList
        sessions={sessions}
        loading={loading}
        error={error}
        pagination={pagination}
        filters={filters}
        snackbarOpen={snackbarOpen}
        snackbarMessage={snackbarMessage}
        onPageChange={handlePageChange}
        onLimitChange={handleLimitChange}
        onFilterChange={handleFilterChange}
        onResetFilters={handleResetFilters}
        onRefresh={handleRefresh}
        onExport={handleExport}
        onViewSession={handleViewSession}
        onSnackbarClose={handleSnackbarClose}
      />

      {/* 세션 상세 모달 */}
      {selectedSession && (
        <SuperChatLog.SessionDetail
          open={sessionDetailOpen}
          session={selectedSession}
          onClose={handleCloseSessionDetail}
        />
      )}
    </Container>
  );
}
